import { Button, Collapse, Divider } from "antd";
import arrow from "../assets/images/shaded-arrow.svg";
import tryGenRxIcon from "../assets/images/try-gen-rx.svg";
import genRxMic from "../assets/images/gen-rx-mic.svg";

import { useState } from "react";
import { getClinicName, trackEvent } from "../utils/utils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const GenRxBox = ({ handleGenRxKnowMore, setIsGenRxDrawerVisible }) => {
  const [isCollapseActive, setIsCollapseActive] = useState(true);
  const { profile } = useSelector((state) => state.doctors);
  const { state } = useLocation();
  const { patient_data } = state;

  const handlePanelChange = () => {
    setIsCollapseActive((prev) => !prev);
  };

  const accordionItems = [
    {
      key: "1",
      label: (
        <div
          style={{
            borderRadius: "20px 20px 0 0",
          }}
          className="d-flex flex-column justify-content-between p-14"
        >
          <>
            <div className="d-flex align-items-center">
              <img
                src={genRxMic}
                alt="ddx-img"
                width={48}
                height={48}
                className="me-3"
              />
              <div
                className="title-common d-flex flex-column"
                style={{ gap: 4 }}
              >
                <span>Voice Rx</span>
              </div>
            </div>
            {isCollapseActive && (
              <div
                style={{
                  paddingTop: 10,
                }}
              >
                Quickly generate structured prescriptions by combining voice and
                type inputs, reducing time and effort in high-volume
                consultations
              </div>
            )}
          </>
        </div>
      ),
      children: (
        <div>
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ gap: 10, paddingTop: "18px", margin:"0 14px" }}
          >
            <Button
              className="btn btn-primary3 btn-41 px-4 w-100 d-flex align-items-center justify-content-center"
              style={{ gap: 10 }}
              onClick={() => {
                const clinic_name = getClinicName(profile?.hospital_data);
                trackEvent("TP_VoiceRx_Start", {
                  patient_contact: patient_data?.pm_contact_no || "",
                  patient_id: patient_data?.patient_unique_id || "",
                  doctor_speciality: profile?.dp_name,
                  doctor_unique_id: profile?.doctor_unique_id,
                  clinic_name,
                });
                setIsGenRxDrawerVisible(true);
              }}
            >
              <img src={tryGenRxIcon} alt="genrx-icon" />
              <span>Try Voice Rx</span>
            </Button>
          </div>
          <Divider />
          <div className="p-14" style={{ paddingTop: 0 }}>
            <div
              className="d-flex align-items-center"
              style={{
                paddingBottom: 10,
                columnGap: 8,
                cursor: "pointer",
                width: "fit-content",
              }}
              onClick={handleGenRxKnowMore}
            >
              <div className="text-primary" style={{ fontWeight: 600 }}>
                Know More About Voice Rx
              </div>
              <img src={arrow} alt="arrow" />
            </div>
            <div
              className="disclaimer-txt"
              style={{
                color: "#A2A2A8",
                fontWeight: 500,
                fontSize: 12,
                paddingBottom: 20,
              }}
            >
              <b style={{ fontWeight: 700 }}>Disclaimer</b>: These results are
              generated by AI. Please double-check all details to ensure they
              are correct and complete.
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Collapse
          items={accordionItems}
          defaultActiveKey={["1"]}
          onChange={handlePanelChange}
          className="tatvaAi-accordian cdss-collapse"
          expandIconPosition={"end"}
        />
      </div>
    </div>
  );
};

export default GenRxBox;
